





































import { Vue, Component, Prop } from "vue-property-decorator";
import Swiper from "swiper";
import "swiper/css/swiper.css";
@Component
export default class JourneySwiper extends Vue {
  @Prop() data!: Array<any>;

  mounted() {
    const galleryThumbs = new Swiper(".gallery-thumbs", {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
    const galleryTop = new Swiper(".gallery-top", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  }
}
